import React, { useState, useEffect } from "react";
import axios from "axios";
import { APILINK } from "../EndPoint";
import ErrorHandler from "../error-handler/ErrorHandler";
import { Container, Row, Col, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { Spin, Empty } from "antd";
const axiosApiInstance = axios.create();
const ViewInstructions = (props) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInstruction = async () => {
    let result = await axiosApiInstance.get(
      APILINK + `/get_instructions/${props.match.params.id}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("lang"),
        },
      }
    );
    console.log(result.data);
    if (result) {
      setData(result.data.data);
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    getInstruction();
  }, []);
  return (
    <Container
      style={{
        textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
      }}
      className="viewSuper align-left usersForm"
    >
      <Row className="mb-4">
        <Col lg={12}>
          <h5>Bank Instruction</h5>
        </Col>
      </Row>
      {data.length !== 0 && loading == false ? (
        data.map((data) => {
          return (
            <Row>
              <Col lg={12}>
                <p>{data.text_ar}</p>
              </Col>
              <Col lg={12}>
                <p>{data.text_en}</p>
              </Col>
            </Row>
          );
        })
      ) : data.length === 0 && loading == false ? (
        <Empty />
      ) : (
        <Spin tip="...loading" />
      )}

      <ToastContainer position="bottom-right" />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(
  mapStateToProps,
  null
)(ErrorHandler(ViewInstructions, axiosApiInstance));
